import script from "./supplier.vue?vue&type=script&setup=true&lang=js"
export * from "./supplier.vue?vue&type=script&setup=true&lang=js"

import "./supplier.vue?vue&type=style&index=0&id=bf51abb6&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf51abb6"]])

export default __exports__